import Vue from "vue";
import axios from "axios";
import Vuex from "vuex";
Vue.use(Vuex);
let baseURL = process.env.VUE_APP_API_URL
let AccessKey = process.env.VUE_APP_ACCESS_KEY

export const actions = {
  // update profile
  // eslint-disable-next-line no-unused-vars
  updateProfile({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${baseURL}user/update`, payload, {
          headers: {
            'access-key': AccessKey,
            'Authorization': `Bearer ${this.state.auth.token}`
          }
        })
        .then((response) => resolve(response))
        .catch((error) => reject(error));
    });
  },

  // create octamile profile
  // eslint-disable-next-line no-unused-vars
  createOtamileProfile({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${baseURL}create-profile`, {}, {
          headers: {
            'access-key': AccessKey,
            'Authorization': `Bearer ${this.state.auth.token}`
          }
        })
        .then((response) => resolve(response))
        .catch((error) => reject(error));
    })
  },

   // update password
  // eslint-disable-next-line no-unused-vars
  updatePassword({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${baseURL}user/update-password`, payload, {
          headers: {
            'access-key': AccessKey,
            'Authorization': `Bearer ${this.state.auth.token}`
          }
        })
        .then((response) => resolve(response))
        .catch((error) => reject(error));
    });
  },

   // create pin
  // eslint-disable-next-line no-unused-vars
  createPin({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${baseURL}user/create-pin`, payload.payload, {
          headers: {
            'access-key': AccessKey,
            'Authorization': `Bearer ${this.state.auth.token}`
          }
        })
        .then((response) => resolve(response))
        .catch((error) => reject(error));
    });
  },

   // validate pin
  // eslint-disable-next-line no-unused-vars
  validatePin({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${baseURL}user/validate-pin`, payload.payload, {
          headers: {
            'access-key': AccessKey,
            'Authorization': `Bearer ${this.state.auth.token}`
          }
        })
        .then((response) => resolve(response))
        .catch((error) => reject(error));
    });
  },

  // eslint-disable-next-line no-unused-vars
  updatePin({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${baseURL}user/update-pin`, payload.payload, {
          headers: {
            'access-key': AccessKey,
            'Authorization': `Bearer ${this.state.auth.token}`
          }
        })
        .then((response) => resolve(response))
        .catch((error) => reject(error));
    });
  },

  sendOTP() {
    return new Promise((resolve, reject) => {
      axios
        .post(`${baseURL}user/reset-pin/start`, {}, {
          headers: {
            'access-key': AccessKey,
            'Authorization': `Bearer ${this.state.auth.token}`
          }
        })
        .then((response) => resolve(response))
        .catch((error) => reject(error));
    });
  },

  // eslint-disable-next-line no-empty-pattern
  resetPin({}, payload) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${baseURL}user/reset-pin/finish`, payload.payload, {
          headers: {
            'access-key': AccessKey,
            'Authorization': `Bearer ${this.state.auth.token}`
          }
        })
        .then((response) => resolve(response))
        .catch((error) => reject(error));
    });
  },
};
